/* Video Carousel.

   In the theme: assets/nextdev-video-carousel.js, loaded by
   sections/nextdev-video-carousel.liquid. Elements are looked up by the
   data-nextdev-vc-* attributes beside the nextdev--video-carousel__* classes.
   Swiper is layout/theme.liquid's.

   The row runs round in a loop, the video in the middle the large one on a
   phone as on a wide screen. That one plays while the row is on screen,
   without sound until the sound button is pressed; once it is, the next
   video in the middle keeps it. When one ends the next comes to the middle.
   The rest are paused. A tap on the video in the middle pauses it, and a
   video paused by hand stays paused until it is tapped again or the row
   moves on. */
(function () {
  'use strict';

  function setup(root) {
    if (root.dataset.nextdevVideoCarouselInit) return;
    var el = root.querySelector('.nextdev--video-carousel__swiper');
    if (!el || typeof window.Swiper !== 'function') return;
    root.dataset.nextdevVideoCarouselInit = '1';

    var inView = false;
    var withSound = false;
    var heldBack = false;

    function parts(slide) {
      return {
        video: slide.querySelector('[data-nextdev-vc-video]'),
        toggle: slide.querySelector('[data-nextdev-vc-toggle]'),
        mute: slide.querySelector('[data-nextdev-vc-mute]'),
        progress: slide.querySelector('[data-nextdev-vc-progress]')
      };
    }

    // the play sign shows only on a video paused by hand, not on one the
    // row paused by moving on
    function markToggle(p) {
      if (!p.toggle || !p.video) return;
      var paused = p.video.paused;
      p.toggle.classList.toggle('nextdev--video-carousel__toggle--paused', paused && heldBack);
      p.toggle.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
    }

    function markMute(p) {
      if (!p.mute || !p.video) return;
      var on = !p.video.muted;
      p.mute.classList.toggle('nextdev--video-carousel__mute--on', on);
      p.mute.setAttribute('aria-pressed', on ? 'true' : 'false');
      p.mute.setAttribute('aria-label', on ? 'Mute video' : 'Unmute video');
    }

    function play(p) {
      if (!p.video) return;
      p.video.muted = !withSound;
      markMute(p);
      var r = p.video.play();
      if (r && typeof r.then === 'function') {
        r.catch(function () {
          // the browser refused the sound without a tap of its own: play muted
          if (!p.video.muted) {
            withSound = false;
            p.video.muted = true;
            markMute(p);
            p.video.play().catch(function () {});
          }
        });
      }
    }

    function activeSlide() {
      return swiper.slides[swiper.activeIndex];
    }

    // only the video in the middle plays, and only while the row is on screen
    function sync() {
      if (!swiper) return;
      var active = activeSlide();
      swiper.slides.forEach(function (slide) {
        var p = parts(slide);
        if (!p.video) return;
        if (slide === active && inView && !heldBack) {
          play(p);
        } else if (!p.video.paused) {
          p.video.pause();
        }
      });
    }

    var swiper = new window.Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: 12,
      loop: true,
      centeredSlides: true,
      slideToClickedSlide: true,
      mousewheel: { forceToAxis: true },
      navigation: {
        prevEl: root.querySelector('[data-nextdev-vc-prev]'),
        nextEl: root.querySelector('[data-nextdev-vc-next]')
      },
      breakpoints: {
        750: { spaceBetween: 16 }
      },
      on: {
        slideChange: function () {
          heldBack = false;
          swiper && swiper.slides.forEach(function (slide) { markToggle(parts(slide)); });
          // after the transition the middle one is known for certain
          window.requestAnimationFrame(sync);
        },
        transitionEnd: sync
      }
    });

    swiper.slides.forEach(function (slide) {
      var p = parts(slide);
      if (!p.video) return;

      // iOS needs these set as properties, not only as attributes
      p.video.muted = true;
      p.video.defaultMuted = true;
      p.video.playsInline = true;

      p.video.addEventListener('timeupdate', function () {
        if (!p.progress) return;
        var along = p.video.duration ? p.video.currentTime / p.video.duration : 0;
        p.progress.style.setProperty('--nextdev-vc-progress', (along * 100).toFixed(2) + '%');
        p.progress.classList.toggle('nextdev--video-carousel__progress--on', along > 0);
      });
      p.video.addEventListener('play', function () { markToggle(p); });
      p.video.addEventListener('pause', function () { markToggle(p); });
      p.video.addEventListener('volumechange', function () { markMute(p); });
      p.video.addEventListener('ended', function () {
        if (slide === activeSlide()) swiper.slideNext();
      });

      if (p.toggle) {
        p.toggle.addEventListener('click', function (event) {
          // a video at the side is brought to the middle by Swiper instead
          if (slide !== activeSlide()) return;
          event.stopPropagation();
          if (p.video.paused) {
            heldBack = false;
            play(p);
          } else {
            heldBack = true;
            p.video.pause();
          }
          markToggle(p);
        });
      }

      if (p.mute) {
        p.mute.addEventListener('click', function (event) {
          event.stopPropagation();
          withSound = p.video.muted;
          p.video.muted = !withSound;
          markMute(p);
          // the tap counts as a gesture, so a video the browser held back starts
          if (p.video.paused && !heldBack) play(p);
        });
      }
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
        sync();
      }, { threshold: 0.35 }).observe(el);
    } else {
      inView = true;
      sync();
    }

    // the theme editor: a block picked in the sidebar comes to the middle
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:block:select', function (event) {
        var slides = Array.prototype.slice.call(el.querySelectorAll('.swiper-slide'));
        for (var i = 0; i < slides.length; i += 1) {
          if (slides[i].dataset.blockId === event.detail.blockId) {
            swiper.slideToLoop(parseInt(slides[i].getAttribute('data-swiper-slide-index'), 10) || 0);
            break;
          }
        }
      });
    }
  }

  function init() {
    var roots = document.querySelectorAll('[data-nextdev-video-carousel]');
    for (var i = 0; i < roots.length; i += 1) setup(roots[i]);
  }

  function start() {
    // Swiper is deferred in the head, so it is normally here already
    if (typeof window.Swiper === 'function') {
      init();
    } else {
      window.addEventListener('load', init, { once: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // the theme editor swaps the section out and back in
  document.addEventListener('shopify:section:load', start);
})();
